import { render } from "./UserPaymentsPage.vue?vue&type=template&id=648e1b08&scoped=true"
import script from "./UserPaymentsPage.vue?vue&type=script&lang=js"
export * from "./UserPaymentsPage.vue?vue&type=script&lang=js"

import "./UserPaymentsPage.vue?vue&type=style&index=0&id=648e1b08&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648e1b08"]])

export default __exports__